var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex",
    class: _vm.$style.layoutContainer
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.containerBody
  }, [_vm._t("default")], 2)]), _c('div', {
    class: _vm.$style.brandContainer
  }, [_c('img', {
    class: _vm.$style.brandLogo,
    attrs: {
      "src": require("@assets/images/mottocenter-new-logo-white.png"),
      "alt": "Logo"
    }
  }), _c('h2', {
    class: _vm.$style.brandSlogan
  }, [_vm._v("Tools to help you every step of the way.")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }